import { css } from "emotion";
import React from "react";
import { Modal, ModalBody } from "reactstrap";
import CloseIcon from "@material-ui/icons/Close";
import moment from "moment-timezone";
import { formatCurrency } from "../../../components/Utils/Currency";
import Img from "../../../components/Img";
import parse from "react-html-parser";

const DetailPanel = (props) => {
  const { transaction, openModal, handleToggle, arrStatus } = props;
  const order = transaction ? transaction?.orders[0] : "";
  const tenant = order ? order?.tenant : "";

  const getOrderStatus = (key) => {
    let find = arrStatus?.find((val) => val.status === key);

    if (find) {
      return find.title;
    } else {
      return "";
    }
  };

  return (
    <Modal
      isOpen={openModal}
      toggle={handleToggle}
      size="lg"
      centered={true}
      zIndex={1300}
      modalClassName={css`
        max-height: 100%;
        overflow-y: scroll !important;
      `}
      contentClassName={css`
        background: none !important;
        border: none !important;
      `}
    >
      <ModalBody>
        {transaction && transaction?.paid === true && (
          <div className="row">
            <div className="col-lg-8 col-12 mb-3">
              <div className="card rounded-8px">
                <div className="w-100 d-flex justify-content-between align-items-center p-3 border-bottom-1-secondary">
                  <span className="font-bold font-20">DETAILS</span>
                  <span
                    className="font-20 text-primary"
                    onClick={() => handleToggle()}
                  >
                    <CloseIcon />
                  </span>
                </div>
                <div className="row w-100 border-bottom-1-secondary mx-0">
                  <div className="col-6 p-3 border-right-1-secondary">
                    <div className="h-100 w-100 d-flex flex-column justify-content-start align-items-start">
                      <span className="font-12 text-gray-757575 d-block">
                        Tanggal Pembelian
                      </span>
                      <span className="font-12 font-bold d-block">
                        {moment(transaction.create_time)
                          .tz(tenant?.property?.timezone)
                          .format("DD MMMM YYYY HH:mm z")}
                      </span>
                    </div>
                  </div>
                  <div className="col-6 p-3">
                    <div className="h-100 w-100 d-flex flex-column justify-content-start align-items-start">
                      <span className="font-12 text-gray-757575 d-block">
                        Status
                      </span>
                      <span className="font-bold font-12 d-block">
                        <label className="badge-blue mb-0">
                          {getOrderStatus(order?.progress)}
                        </label>
                      </span>
                    </div>
                  </div>
                </div>
                <h4 className="font-bold font-12 p-3 mb-0">Daftar Pesanan</h4>
                <div className="w-100 p-3 border-bottom-1-secondary">
                  {order?.items?.map((item, index) => (
                    <div
                      className={
                        index === 0
                          ? "d-flex w-100 justify-content-start align-items-start py-3"
                          : "d-flex w-100 justify-content-start align-items-start py-3 border-top-1-secondary"
                      }
                      key={index}
                    >
                      <Img
                        src={item.main_image || item.image_urls[0]}
                        style={{ width: 36, height: 36 }}
                      />
                      <div className="ml-3">
                        <span className="font-10 text-gray-757575 d-block">
                          {tenant?.name}
                        </span>
                        <span className="font-12 font-bold d-block mb-1">
                          {item?.name}
                        </span>
                        <span className="font-10 d-block">
                          {item.qty} Item x{" "}
                          {formatCurrency(
                            tenant?.property?.currency,
                            (item.discounted_price && item.discounted_price > 0
                              ? item.discounted_price
                              : item.price.value
                            ).toString()
                          )}
                        </span>
                        {item?.note && item?.note !== "" && (
                          <span className="font-10 d-block">
                            Note = {item?.note}
                          </span>
                        )}
                      </div>
                      <div
                        className="ml-auto text-left"
                        style={{ width: "30%" }}
                      >
                        <span className="font-10 text-gray-757575 d-block">
                          Total Product Price
                        </span>
                        <span className="font-12 text-blue d-block">
                          {formatCurrency(
                            tenant?.property?.currency,
                            (item.discounted_price && item.discounted_price > 0
                              ? item.discounted_price * item.qty
                              : item.price.value * item.qty
                            ).toString()
                          )}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
                <h4 className="font-bold font-12 px-3 pt-3 mb-0">
                  Rincian Pembayaran
                </h4>
                <div className="w-100 p-3 border-bottom-1-secondary">
                  <table className="table table-no-border w-100">
                    <tbody>
                      <tr>
                        <td
                          width="60%"
                          className="p-0 font-10 text-gray-757575"
                        >
                          Total Harga ({order?.items?.length} Produk)
                        </td>
                        <td
                          width="40%"
                          className="border-left-1-d8d8d8 p-0 pl-4 font-10 font-bold text-gray-757575 text-left"
                        >
                          {formatCurrency(
                            tenant?.property?.currency,
                            (
                              order.sub_total_amount -
                              order.service_charge_amount -
                              order.tax_charge_amount
                            ).toString()
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td
                          width="60%"
                          className="p-0 font-10 text-gray-757575"
                        >
                          Service ({tenant.service_charge_percentage}%)
                        </td>
                        <td
                          width="40%"
                          className="border-left-1-d8d8d8 p-0 pl-4 font-10 font-bold text-gray-757575 text-left"
                        >
                          {formatCurrency(
                            tenant?.property?.currency,
                            order.service_charge_amount.toString()
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td
                          width="60%"
                          className="p-0 font-10 text-gray-757575"
                        >
                          Tax ({tenant.tax_charge_percentage}%)
                        </td>
                        <td
                          width="40%"
                          className="border-left-1-d8d8d8 p-0 pl-4 font-10 font-bold text-gray-757575 text-left"
                        >
                          {formatCurrency(
                            tenant?.property?.currency,
                            order.tax_charge_amount.toString()
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td
                          width="60%"
                          className="p-0 font-10 text-gray-757575"
                        >
                          Total
                        </td>
                        <td
                          width="40%"
                          className="border-left-1-d8d8d8 p-0 pl-4 font-10 font-bold text-success text-left"
                        >
                          {formatCurrency(
                            tenant?.property?.currency,
                            order.sub_total_amount.toString()
                          )}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <h4 className="font-bold font-12 px-3 pt-3 mb-0">
                  Status Pesanan
                </h4>
                <div className="w-100 p-3">
                  {transaction?.order_logs &&
                    transaction?.order_logs?.length > 0 && (
                      <ul className="vertical-timeline">
                        {transaction?.order_logs?.map((log, key) => (
                          <li
                            className={
                              key === transaction?.order_logs?.length - 1
                                ? "my-2 active"
                                : "my-2"
                            }
                            key={key}
                          >
                            <div className="d-flex flex-column justify-content-start align-items-start ml-3 w-100">
                              <span
                                className={
                                  key === transaction?.order_logs?.length - 1
                                    ? "font-10 text-primary"
                                    : "font-10 text-muted"
                                }
                              >
                                {moment(log?.create_time)
                                  .tz(tenant?.property?.timezone)
                                  .format("DD MMM, YYYY H:mm z")}
                              </span>
                              {log?.progress === "waiting" && (
                                <span className="font-12 text-primary my-1">
                                  Waiting Payment
                                </span>
                              )}
                              {log?.progress === "new" && (
                                <span className="font-12 text-primary my-1">
                                  Payment Success, Waiting for confirmation
                                </span>
                              )}
                              {log?.progress === "process" && (
                                <span className="font-12 text-primary my-1">
                                  Process
                                </span>
                              )}
                              {log?.progress === "ready" && (
                                <span className="font-12 text-primary my-1">
                                  Ready For Pickup
                                </span>
                              )}
                              {log?.progress === "delivery" && (
                                <span className="font-12 text-primary my-1">
                                  On Delivery
                                </span>
                              )}
                              {log?.progress === "complete" && (
                                <span className="font-12 text-primary my-1">
                                  Complete
                                </span>
                              )}
                              {log?.progress === "cancel" && (
                                <span className="font-12 text-primary my-1">
                                  Cancel
                                </span>
                              )}
                              {log?.progress === "failed" && (
                                <span className="font-12 text-primary my-1">
                                  Failed Delivery
                                </span>
                              )}
                              {log.progress === "delivery" &&
                                log?.delivery_logs &&
                                log?.delivery_logs?.length > 0 && (
                                  <ul className="vertical-timeline">
                                    {log?.delivery_logs?.map((dlog, index) => (
                                      <li
                                        className={
                                          index ===
                                          log?.delivery_logs?.length - 1
                                            ? "my-2 active"
                                            : "my-2"
                                        }
                                        key={index}
                                      >
                                        <div className="d-flex flex-column justify-content-start align-items-start ml-3 w-100">
                                          <span
                                            className={
                                              index ===
                                              log?.delivery_logs?.length - 1
                                                ? "font-10 text-primary"
                                                : "font-10 text-muted"
                                            }
                                          >
                                            {moment(dlog?.time)
                                              .tz(tenant?.property?.timezone)
                                              .format("DD MMM, YYYY H:mm z")}
                                          </span>
                                          <span className="font-12 text-primary my-1">
                                            {dlog?.description}
                                          </span>
                                        </div>
                                      </li>
                                    ))}
                                  </ul>
                                )}
                            </div>
                          </li>
                        ))}
                      </ul>
                    )}
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-12">
              <div className="card rounded-8px pb-3">
                <div className="w-100 p-3 border-bottom-1-secondary">
                  <div className="h-100 w-100 d-flex flex-column justify-content-start align-items-start">
                    <span className="font-12 text-gray-757575 d-block">
                      Type
                    </span>
                    <span className="font-bold font-12 d-block">
                      {transaction?.use_delivery && (
                        <label className="badge-purple mb-0">
                          Delivery Order
                        </label>
                      )}
                      {!transaction?.use_delivery &&
                        transaction?.pickup &&
                        transaction?.pickup?.id !== 0 && (
                          <label className="badge-blue mb-0">Self Pickup</label>
                        )}
                      {!transaction?.use_delivery &&
                        transaction?.delivery &&
                        transaction.delivery.id > 0 && (
                          <label className="badge-purple mb-0">
                            Delivery Order
                          </label>
                        )}
                      {!transaction?.use_delivery &&
                        transaction?.cons_type &&
                        transaction?.cons_type === "room" && (
                          <label className="badge-orange mb-0">
                            Send To Room : {transaction?.room_number}
                          </label>
                        )}
                      {!transaction?.use_delivery &&
                        transaction?.cons_type &&
                        transaction?.cons_type === "table" && (
                          <label className="badge-orange mb-0">
                            Send To Table : {transaction?.table_number}
                          </label>
                        )}
                    </span>
                  </div>
                </div>
                {transaction.voucher && (
                  <div className="w-100 p-3 border-bottom-1-secondary">
                    <div className="h-100 w-100 d-flex flex-column justify-content-start align-items-start">
                      <span className="font-12 text-gray-757575 d-block">
                        Voucher yang digunakan
                      </span>
                      <span className="font-bold mt-2 font-12 d-block">
                        <label className="badge-purple mb-0">
                          {transaction?.voucher?.name}{" "}
                          {`(${transaction?.voucher?.code})`}
                        </label>
                      </span>
                    </div>
                  </div>
                )}{" "}
                <div className="w-100 p-3 border-bottom-1-secondary">
                  <div className="h-100 w-100 d-flex flex-column justify-content-start align-items-start">
                    <span className="font-12 text-gray-757575 d-block">
                      No. Transaksi
                    </span>
                    <span className="font-bold font-12 d-block">
                      {transaction?.unique_id}
                    </span>
                  </div>
                </div>
                <div className="w-100 p-3 border-bottom-1-secondary">
                  <div className="h-100 w-100 d-flex flex-column justify-content-start align-items-start">
                    <span className="font-12 text-gray-757575 d-block">
                      Pick Up Point
                    </span>
                    <span className="font-bold font-12 d-block">
                      {transaction?.pickup?.name || "-"}
                    </span>
                  </div>
                </div>
                <div className="w-100 p-3 border-bottom-1-secondary">
                  <div className="h-100 w-100 d-flex flex-column justify-content-start align-items-start">
                    <span className="font-12 text-gray-757575 d-block">
                      Total Belanja
                    </span>
                    <span className="font-bold text-success font-12 d-block">
                      {formatCurrency(
                        tenant?.property?.currency,
                        order.sub_total_amount.toString()
                      )}
                    </span>
                  </div>
                </div>
                {transaction?.use_delivery && (
                  <div className="w-100 p-3 border-bottom-1-secondary">
                    <div className="h-100 w-100 d-flex flex-column justify-content-start align-items-start">
                      <span className="font-12 text-gray-757575 d-block">
                        Alamat Pengiriman
                      </span>
                      <span className="font-bold font-12 d-block">
                        {transaction?.user?.name}
                      </span>
                      <p className="font-12 text-gray-757575">
                        {parse(
                          `${transaction?.customer_address.detail_address}<br/>${transaction?.customer_address.subdistrict.name}, ${transaction?.customer_address.district.name}, ${transaction?.customer_address.province.name}`
                        )}
                      </p>
                    </div>
                  </div>
                )}
                {!transaction?.use_delivery &&
                  transaction?.delivery &&
                  transaction?.delivery?.id > 0 && (
                    <div className="w-100 p-3 border-bottom-1-secondary">
                      <div className="h-100 w-100 d-flex flex-column justify-content-start align-items-start">
                        <span className="font-12 text-gray-757575 d-block">
                          Alamat Pengiriman
                        </span>
                        <span className="font-bold font-12 d-block">
                          {transaction?.user?.name}
                        </span>
                        <p className="font-12 text-gray-757575">
                          {transaction?.delivery?.consignee_address}
                        </p>
                      </div>
                    </div>
                  )}
                {transaction?.transaction_note &&
                  transaction?.transaction_note !== "" && (
                    <div className="col-12 px-3 py-2 mb-2">
                      <p
                        className="font-12 p-2"
                        style={{
                          background: "#ffecb3",
                          borderLeft: "6px solid #ff9800",
                          borderRadius: 4,
                        }}
                      >
                        <strong>Catatan Pembeli: </strong>{" "}
                        {transaction?.transaction_note}
                      </p>
                    </div>
                  )}
              </div>
            </div>
          </div>
        )}
        {transaction && transaction?.paid === false && (
          <div className="row">
            <div className="col-lg-8 col-12 mb-3">
              <div className="card rounded-8px">
                <div className="w-100 d-flex justify-content-between align-items-center p-3 border-bottom-1-secondary">
                  <span className="font-bold font-20">DETAILS</span>
                  <span
                    className="font-20 text-primary"
                    onClick={() => handleToggle()}
                  >
                    <CloseIcon />
                  </span>
                </div>
                <div className="row w-100 border-bottom-1-secondary mx-0">
                  <div className="col-6 p-3 border-right-1-secondary">
                    <div className="h-100 w-100 d-flex flex-column justify-content-start align-items-start">
                      <span className="font-12 text-gray-757575 d-block">
                        Tanggal Pembelian
                      </span>
                      <span className="font-12 font-bold d-block">
                        {moment(transaction.create_time)
                          .tz(tenant?.property?.timezone)
                          .format("DD MMMM YYYY HH:mm z")}
                      </span>
                    </div>
                  </div>
                  <div className="col-6 p-3">
                    <div className="h-100 w-100 d-flex flex-column justify-content-start align-items-start">
                      <span className="font-12 text-gray-757575 d-block">
                        Status Pembayaran
                      </span>
                      <span className="font-bold font-12 d-block">
                        {transaction?.invoice &&
                          transaction?.invoice?.status === "PENDING" && (
                            <label className="badge-blue mb-0">PENDING</label>
                          )}
                        {transaction?.invoice &&
                          transaction?.invoice?.status === "EXPIRED" && (
                            <label className="badge-orange mb-0">EXPIRED</label>
                          )}
                      </span>
                    </div>
                  </div>
                </div>
                <h4 className="font-bold font-12 px-3 pt-3 mb-0">
                  Rincian Invoice
                </h4>
                <div className="w-100 p-3 border-bottom-1-secondary">
                  <table className="table table-no-border w-100">
                    <tbody>
                      <tr>
                        <td
                          width="60%"
                          className="p-2 font-10 text-gray-757575"
                        >
                          Invoice ID
                        </td>
                        <td
                          width="40%"
                          className="border-left-1-d8d8d8 p-2 font-10 font-bold text-gray-757575 text-left"
                        >
                          {transaction?.invoice?.id || "-"}
                        </td>
                      </tr>
                      <tr>
                        <td
                          width="60%"
                          className="p-2 font-10 text-gray-757575"
                        >
                          External ID
                        </td>
                        <td
                          width="40%"
                          className="border-left-1-d8d8d8 p-2 font-10 font-bold text-gray-757575 text-left"
                        >
                          {transaction?.invoice?.external_id || "-"}
                        </td>
                      </tr>
                      <tr>
                        <td
                          width="60%"
                          className="p-2 font-10 text-gray-757575"
                        >
                          Invoice URL
                        </td>
                        <td
                          width="40%"
                          className="border-left-1-d8d8d8 p-2 font-10 font-bold text-gray-757575 text-left"
                        >
                          <code>
                            {transaction?.invoice?.invoice_url || "-"}
                          </code>
                        </td>
                      </tr>
                      <tr>
                        <td
                          width="60%"
                          className="p-2 font-10 text-gray-757575"
                        >
                          Expired Date
                        </td>
                        <td
                          width="40%"
                          className="border-left-1-d8d8d8 p-2 font-10 font-bold text-gray-757575 text-left"
                        >
                          {moment(transaction?.invoice?.expiry_date || "")
                            .tz(tenant?.property?.timezone)
                            .format("DD MMMM YYYY HH:mm z")}
                        </td>
                      </tr>
                    </tbody>
                    {transaction?.invoice?.available_banks &&
                      transaction?.invoice?.available_banks?.length > 0 && (
                        <tbody>
                          <tr>
                            <td className="p-2 font-12 font-bold" colSpan="2">
                              Available Banks
                            </td>
                          </tr>
                          {transaction?.invoice?.available_banks?.map(
                            (bank, b) => (
                              <tr key={"bank-" + b}>
                                <td className="p-2 font-11 font-bold">
                                  {bank?.bank_code}
                                </td>
                                <td className="border-left-1-d8d8d8 p-2 font-10 font-bold text-gray-757575 text-left">
                                  <ul>
                                    <li>
                                      <strong>Bank Branch:</strong>{" "}
                                      {bank?.bank_branch || "-"}
                                    </li>
                                    <li>
                                      <strong>Bank Account Number:</strong>{" "}
                                      {bank?.bank_account_number || "-"}
                                    </li>
                                    <li>
                                      <strong>Transfer Amount:</strong>{" "}
                                      {formatCurrency(
                                        tenant?.property?.currency,
                                        bank?.transfer_amount.toString()
                                      )}
                                    </li>
                                  </ul>
                                </td>
                              </tr>
                            )
                          )}
                        </tbody>
                      )}
                    {transaction?.invoice?.available_retail_outlets &&
                      transaction?.invoice?.available_retail_outlets?.length >
                        0 && (
                        <tbody>
                          <tr>
                            <td className="p-2 font-12 font-bold" colSpan="2">
                              Available Retail Outlets
                            </td>
                          </tr>
                          {transaction?.invoice?.available_retail_outlets?.map(
                            (retail, b) => (
                              <tr key={"retail-" + b}>
                                <td className="p-2 font-11 font-bold">
                                  {retail?.retail_outlet_name}
                                </td>
                                <td className="border-left-1-d8d8d8 p-2 font-10 font-bold text-gray-757575 text-left">
                                  <ul>
                                    <li>
                                      <strong>Payment Code:</strong>{" "}
                                      {retail?.payment_code || "-"}
                                    </li>
                                    <li>
                                      <strong>Transfer Amount:</strong>{" "}
                                      {formatCurrency(
                                        tenant?.property?.currency,
                                        retail?.transfer_amount.toString()
                                      )}
                                    </li>
                                  </ul>
                                </td>
                              </tr>
                            )
                          )}
                        </tbody>
                      )}
                    {transaction?.invoice?.available_ewallets &&
                      transaction?.invoice?.available_ewallets?.length > 0 && (
                        <tbody>
                          <tr>
                            <td className="p-2 font-12 font-bold" colSpan="2">
                              Available E-Wallets
                            </td>
                          </tr>
                          {transaction?.invoice?.available_ewallets?.map(
                            (wallet, b) => (
                              <tr key={"wallet-" + b}>
                                <td className="p-2 font-11 font-bold">
                                  {wallet?.retail_outlet_name}
                                </td>
                              </tr>
                            )
                          )}
                        </tbody>
                      )}
                  </table>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-12">
              <div className="card rounded-8px pb-3">
                <div className="w-100 p-3 border-bottom-1-secondary">
                  <div className="h-100 w-100 d-flex flex-column justify-content-start align-items-start">
                    <span className="font-12 text-gray-757575 d-block">
                      Type
                    </span>
                    <span className="font-bold font-12 d-block">
                      {transaction?.use_delivery && (
                        <label className="badge-purple mb-0">
                          Delivery Order
                        </label>
                      )}
                      {!transaction?.use_delivery &&
                        transaction?.pickup &&
                        transaction?.pickup?.id !== 0 && (
                          <label className="badge-blue mb-0">Self Pickup</label>
                        )}
                      {!transaction?.use_delivery &&
                        transaction?.delivery &&
                        transaction.delivery.id > 0 && (
                          <label className="badge-purple mb-0">
                            Delivery Order
                          </label>
                        )}
                      {!transaction?.use_delivery &&
                        transaction?.cons_type &&
                        transaction?.cons_type === "room" && (
                          <label className="badge-orange mb-0">
                            Send To Room : {transaction?.room_number}
                          </label>
                        )}
                      {!transaction?.use_delivery &&
                        transaction?.cons_type &&
                        transaction?.cons_type === "table" && (
                          <label className="badge-orange mb-0">
                            Send To Table : {transaction?.table_number}
                          </label>
                        )}
                    </span>
                  </div>
                </div>
                <div className="w-100 p-3 border-bottom-1-secondary">
                  <div className="h-100 w-100 d-flex flex-column justify-content-start align-items-start">
                    <span className="font-12 text-gray-757575 d-block">
                      No. Transaksi
                    </span>
                    <span className="font-bold font-12 d-block">
                      {transaction?.unique_id}
                    </span>
                  </div>
                </div>
                <div className="w-100 p-3 border-bottom-1-secondary">
                  <div className="h-100 w-100 d-flex flex-column justify-content-start align-items-start">
                    <span className="font-12 text-gray-757575 d-block">
                      Pick Up Point
                    </span>
                    <span className="font-bold font-12 d-block">
                      {transaction?.pickup?.name || "-"}
                    </span>
                  </div>
                </div>
                <div className="w-100 p-3 border-bottom-1-secondary">
                  <div className="h-100 w-100 d-flex flex-column justify-content-start align-items-start">
                    <span className="font-12 text-gray-757575 d-block">
                      Total Transaksi
                    </span>
                    <span className="font-bold text-success font-12 d-block">
                      {formatCurrency(
                        tenant?.property?.currency,
                        transaction?.total_amount.toString()
                      )}
                    </span>
                  </div>
                </div>
                {transaction?.use_delivery && (
                  <div className="w-100 p-3 border-bottom-1-secondary">
                    <div className="h-100 w-100 d-flex flex-column justify-content-start align-items-start">
                      <span className="font-12 text-gray-757575 d-block">
                        Alamat Pengiriman
                      </span>
                      <span className="font-bold font-12 d-block">
                        {transaction?.user?.name}
                      </span>
                      <p className="font-12 text-gray-757575">
                        {parse(
                          `${transaction?.customer_address.detail_address}<br/>${transaction?.customer_address.subdistrict.name}, ${transaction?.customer_address.district.name}, ${transaction?.customer_address.province.name}`
                        )}
                      </p>
                    </div>
                  </div>
                )}
                {!transaction?.use_delivery &&
                  transaction?.delivery &&
                  transaction?.delivery?.id > 0 && (
                    <div className="w-100 p-3 border-bottom-1-secondary">
                      <div className="h-100 w-100 d-flex flex-column justify-content-start align-items-start">
                        <span className="font-12 text-gray-757575 d-block">
                          Alamat Pengiriman
                        </span>
                        <span className="font-bold font-12 d-block">
                          {transaction?.user?.name}
                        </span>
                        <p className="font-12 text-gray-757575">
                          {transaction?.delivery?.consignee_address}
                        </p>
                      </div>
                    </div>
                  )}
                {transaction?.transaction_note &&
                  transaction?.transaction_note !== "" && (
                    <div className="col-12 px-3 py-2 mb-2">
                      <p
                        className="font-12 p-2"
                        style={{
                          background: "#ffecb3",
                          borderLeft: "6px solid #ff9800",
                          borderRadius: 4,
                        }}
                      >
                        <strong>Catatan Pembeli: </strong>{" "}
                        {transaction?.transaction_note}
                      </p>
                    </div>
                  )}
              </div>
            </div>
          </div>
        )}
      </ModalBody>
    </Modal>
  );
};

export default DetailPanel;
